export enum RESPONSE_NEW_PASSWORD{
    CODIGO_CADUCADO = 1,
    CODIGO_INCORRECTO = 2,
    CANTIDAD_REINTENTOS_SUPERADA = 3,
    CONTRASEÑA_MODIFICADA = 4
}